import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// Home pages
import Homepage from "../HomePage";
import HomePage2 from "../HomePage2/HomePage2";
import HomePage3 from "../HomePage3/HomePage3";

// Inner pages
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";
import CareerSection from "../CareerSection/CareerSection";
import CareerDetails from "../CareerDetails/CareerDetails";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectDetails from "../ProjectDetails/ProjectDetails";
import TeamPage from "../TeamPage/TeamPage";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";

// Service pages
import ASICSoCDesignPage from "../ServicePages/ASICSoCDesign";
import VerificationPage from "../ServicePages/Verification";
import PhysicalDesignPage from "../ServicePages/PhysicalDesign";
import DFTPage from "../ServicePages/DFT";
import SiliconRealizationPage from "../ServicePages/SiliconRealization";
import AnalogMixedSignalPage from "../ServicePages/AnalogMixedSignal";
import StaticTimingAnalysisPage from "../ServicePages/StaticTimingAnalysis";
import FPGAEngineeringPage from "../ServicePages/FPGAEngineering";
import EmbeddedSoftwareSystemsPage from "../ServicePages/EmbeddedSoftwareSystems";
import HardwarePlatformEngineeringPage from "../ServicePages/HardwarePlatformEngineering";
import NetworkingSolutionsPage from "../ServicePages/NetworkingSolutions";
import SiliconValidationPage from "../ServicePages/SiliconValidation";
import EDADesignAutomationPage from "../ServicePages/EDADesignAutomation";
import ProductEngineeringPage from "../ServicePages/ProductEngineering";

// Solution pages
import EngineeringTeamExtensionPage from "../SolutionPages/EngineeringTeamExtension";
import ProjectOwnershipPage from "../SolutionPages/ProjectOwnership";
import EndToEndSiliconDevelopmentPage from "../SolutionPages/EndToEndSiliconDevelopment";
import EngineeringProductDesignPage from "../SolutionPages/EngineeringProductDesign";
import ProductRealizationPage from "../SolutionPages/ProductRealization";
import SolutionsOverviewPage from "../SolutionPages/SolutionsOverview";

import IPAcceleratorsPage from "../EngineeringPages/IPAccelerators";
import IndustriesPage from "../EngineeringPages/Industries";

// Content pages
import TeamMemberPage from "../ContentPages/TeamMemberPage";
import {
  TapeoutsPage,
  CaseStudiesPage,
  WhyDigicommPage,
} from "../ContentPages/LandingPages";

// Insights pages
import InsightsPage from "../InsightsPage/InsightsPage";
import InsightsDetails from "../InsightsDetails/InsightsDetails";

import ScrollToTop from "./ScrollToTop";

const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <WowInit />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />

        <Route path="/ai-marketing" element={<HomePage2 />} />
        <Route path="/ai-chatbot" element={<HomePage3 />} />

        <Route path="/about" element={<AboutPage />} />
        <Route path="/why-digicomm" element={<WhyDigicommPage />} />

        <Route path="/service" element={<ServicePage />} />
        <Route path="/service-details" element={<SeviceSinglePage />} />
        <Route path="/services/asic-soc-design" element={<ASICSoCDesignPage />} />
        <Route path="/services/verification" element={<VerificationPage />} />
        <Route path="/services/physical-design" element={<PhysicalDesignPage />} />
        <Route path="/services/dft" element={<DFTPage />} />
        <Route path="/services/silicon-realization" element={<SiliconRealizationPage />} />
        <Route path="/services/analog-mixed-signal" element={<AnalogMixedSignalPage />} />
        <Route path="/services/static-timing-analysis" element={<StaticTimingAnalysisPage />} />
        <Route path="/services/fpga-engineering" element={<FPGAEngineeringPage />} />
        <Route
          path="/services/embedded-software-systems"
          element={<EmbeddedSoftwareSystemsPage />}
        />
        <Route
          path="/services/hardware-platform-engineering"
          element={<HardwarePlatformEngineeringPage />}
        />
        <Route
          path="/services/networking-solutions"
          element={<NetworkingSolutionsPage />}
        />
        <Route
          path="/services/silicon-validation"
          element={<SiliconValidationPage />}
        />
        <Route
          path="/services/eda-design-automation"
          element={<EDADesignAutomationPage />}
        />
        <Route
          path="/services/product-engineering"
          element={<ProductEngineeringPage />}
        />

        <Route path="/career" element={<CareerSection />} />
        <Route path="/careers" element={<CareerSection />} />
        <Route path="/career-details" element={<CareerDetails />} />
        <Route path="/career-details/:slug" element={<CareerDetails />} />

        <Route path="/project" element={<ProjectPage />} />
        <Route path="/project-details" element={<ProjectDetails />} />

        <Route path="/solutions" element={<SolutionsOverviewPage />} />
        <Route
          path="/solutions/engineering-team-extension"
          element={<EngineeringTeamExtensionPage />}
        />
        <Route
          path="/solutions/project-ownership"
          element={<ProjectOwnershipPage />}
        />
        <Route
          path="/solutions/end-to-end-silicon-development"
          element={<EndToEndSiliconDevelopmentPage />}
        />
        <Route
          path="/solutions/engineering-product-design"
          element={<EngineeringProductDesignPage />}
        />
        <Route
          path="/solutions/product-realization"
          element={<ProductRealizationPage />}
        />

        <Route path="/tapeouts" element={<TapeoutsPage />} />
        <Route path="/ip-accelerators" element={<IPAcceleratorsPage />} />
        <Route path="/industries" element={<IndustriesPage />} />

        <Route path="/team" element={<TeamPage />} />
        <Route path="/team-single/:slug" element={<TeamMemberPage />} />

        {/* BLOG URL NOW SHOWS INSIGHTS */}
        <Route path="/blog" element={<InsightsPage />} />
        <Route path="/blog-details" element={<InsightsDetails />} />

        {/* DIRECT INSIGHTS URL */}
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/insights/:slug" element={<InsightsDetails />} />

        <Route path="/resources" element={<Navigate to="/blog" replace />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />

        <Route path="/contact" element={<ContactPage />} />

        <Route path="/404" element={<ErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </div>
  );
};

export default AllRoute;
